import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import t from '../service/translate.service'
import LoadingPageOverlay from '../components/LoadingPageOverlay'
import { Alert } from 'antd'
import { useState } from 'react'
import { extractError } from '../service/response.service'
import user from "../store/user.store";

export const RegistrationInvitePage = () => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(true)
  const params = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    ;(async () => {
      try {
        const res = await user.confirmRegistrationInvitation(params?.code)
        if (res?.proceedToken) {
          navigate(`/register?proceedToken=${res.proceedToken}`)
        } else {
          setError(t['REGISTRATION_INVITATION_INVALID_LINK'])
        }
        setLoading(false)
      } catch (error) {
        setError(t[extractError(error)] || t["ERROR"])
        setLoading(false)
      }
    })()
  }, [])

  if (loading) {
    return <LoadingPageOverlay />
  }

  return (
    <div className="wrapper">
      {error && (
        <Alert
          message={error}
          type="error"
          style={{ marginTop: '12px', marginBottom: '12px' }}
        />
      )}
    </div>
  )
}
